import { createTheme } from '@mui/material/styles';

/**
 * MUI theme for the (MUI-based) admin panel. Kept intentionally lightweight and
 * WITHOUT CssBaseline at the root so it doesn't clobber the Bootstrap-styled
 * public site during the incremental MUI migration.
 */
const theme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: '#0d6efd' }, // aligns with the Bootstrap primary
        secondary: { main: '#198754' },
    },
    shape: { borderRadius: 8 },
});

export default theme;
